export enum ProductsSortingKey {
  Relevance = 'relevance',
  AscPrice = 'ascPrice',
  DescPrice = 'descPrice',
  DescDiscount = 'descDiscount',
}
